module.exports = __webpack_public_path__ + "img/dropdown-search-chevy.5caff481.png";